/* global fetch, */
import { PAYPAL_API_URLS } from './paypal-constants';
import { setSessionUrls, clearLocalStorage } from './paypal-utils';

const createOrder = (data, actions) => {
	//Clear Previous Payopal State If Set
	clearLocalStorage();

	return fetch(PAYPAL_API_URLS.create, {
		method: 'post'
	}).then(function (res) {
		return res.json();
	}).then(function (response) {
		if(response.sessionUrls) {
			setSessionUrls(response.sessionUrls);
		}

		return response.orderID || response.token;
	});
};

module.exports = createOrder;
